export default "__VITE_ASSET__D7EKGbP8__"